export default (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.94028 9.31019C4.3545 8.72441 4.3545 7.77466 4.94028 7.18887L10.9403 1.18885C11.5261 0.603065 12.4758 0.603065 13.0616 1.18885L14.5618 2.68902C15.1476 3.27481 15.1476 4.22456 14.5618 4.81034L8.56177 10.8104C7.97599 11.3962 7.02624 11.3962 6.44045 10.8104L4.94028 9.31019ZM12.001 2.24951L6.00094 8.24953L7.50111 9.7497L13.5011 3.74968L12.001 2.24951Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1904 17.5602C12.6046 16.9744 12.6046 16.0247 13.1904 15.4389L19.1904 9.43885C19.7762 8.85307 20.7259 8.85307 21.3117 9.43885L22.8119 10.939C23.3977 11.5248 23.3977 12.4746 22.8119 13.0603L16.8118 19.0604C16.2261 19.6462 15.2763 19.6462 14.6905 19.0604L13.1904 17.5602ZM20.251 10.4995L14.251 16.4995L15.7512 17.9997L21.7512 11.9997L20.251 10.4995Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1253 4.1253C13.4182 3.83241 13.8931 3.83241 14.186 4.1253L19.8747 9.81405C20.1676 10.1069 20.1676 10.5818 19.8747 10.8747C19.5818 11.1676 19.1069 11.1676 18.8141 10.8747L13.1253 5.18596C12.8324 4.89307 12.8324 4.4182 13.1253 4.1253Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8753 9.3753C8.1682 9.08241 8.64307 9.08241 8.93596 9.3753L14.6247 15.0641C14.9176 15.3569 14.9176 15.8318 14.6247 16.1247C14.3318 16.4176 13.8569 16.4176 13.5641 16.1247L7.8753 10.436C7.58241 10.1431 7.58241 9.6682 7.8753 9.3753Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6553 11.0947C10.9482 11.3876 10.9482 11.8624 10.6553 12.1553L4 18.8107C3.84266 18.9688 3.75391 19.1832 3.75391 19.4063C3.75391 19.6291 3.84205 19.8428 3.99907 20.0009C4.15713 20.158 4.37091 20.2461 4.59376 20.2461C4.81686 20.2461 5.03088 20.1577 5.18899 20.0004L11.8447 13.3447C12.1376 13.0518 12.6124 13.0518 12.9053 13.3447C13.1982 13.6376 13.1982 14.1124 12.9053 14.4053L6.24817 21.0625C5.80887 21.5003 5.21395 21.7461 4.59376 21.7461C3.97356 21.7461 3.37865 21.5003 2.93934 21.0625L2.93751 21.0607C2.49972 20.6214 2.25391 20.0265 2.25391 19.4063C2.25391 18.7861 2.49972 18.1912 2.93751 17.7518L9.59468 11.0947C9.88757 10.8018 10.3624 10.8018 10.6553 11.0947Z"
      fill="currentColor"
    />
  </>
);
